import React, { useEffect, useState } from "react";
import {
  Page,
  Title,
  DivMain,
  Table,
  Theader,
  Th,
  Tbody,
  Trbody,
  Td,
  Buttons,
  Menus,
  ContainerTable,
  TdDisciplina,
  Description,
  DivText,
} from "./styles";
import { useNavigate } from "react-router-dom";
import Button from "../../../Components/Button/index.jsx";
import api from "../../../Services/api.js";
import { format } from "date-fns";
import { Alert } from "../../../utils/Alert.js";
// import { MdInfo } from "react-icons/md";
import { LuEye } from "react-icons/lu";
// import { FaFilePdf } from "react-icons/fa6";
// import CardVerPdfProgressao from "../../../Components/ProgressaoParcial/CardVerPdfProgressao/index.jsx";
import CardListarAlunosPP from "../../../Components/ProgressaoParcial/CardListarAlunosPP/index.jsx";
import Loading from "../../../utils/Loading";
import InputSelect from "../../../Components/Select/index.jsx";
// import CardVerInformacoes from "../../../Components/ProgressaoParcial/CardVerInformacoes/index.jsx";

export const ProgressaoParcialSecretaria = () => {
  const Navigate = useNavigate();
  const [progressaoEdit, setProgressaoEdit] = useState([]);
  const [progressoes, setProgressoes] = useState([]);
  // const [pdfProgressao, setPdfProgressao] = useState(false);
  const [MostrarAlunos, setMostrarAlunos] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [showForm, setShowForm] = useState(false);
  const [pc, setPc] = useState(window.innerWidth > 1000);
  const [cursos, setCursos] = useState([]);
  const [cursoSelecionado, setCursoSelecionado] = useState("todos");

  useEffect(() => {
    const handleResize = () => {
      setPc(window.innerWidth > 1000);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setLoading(true);
    ListarProgressoes();
  }, []);

  const OptionsSelect = [
    { value: "todos", label: "Todos os Cursos" },
    ...cursos.map((curso) => ({
      value: curso,
      label: curso,
    })),
  ];

  async function ListarProgressoes() {
    try {
      const res = await api.get("/usuario/listar-todas-progressoes");

      const { progressoes: progressoesData, progressoesComPendencias } = res.data;

      const progressoesAtualizadas = progressoesData.map((p) => {
        if (progressoesComPendencias?.includes(p.id)) {
          return { ...p, emAvaliacao: true };
        }
        return { ...p, emAvaliacao: false };
      });

      setProgressoes(progressoesAtualizadas);
      // console.log(progressoesAtualizadas);

      const cursosUnicos = Array.from(
        new Set(
          res.data.progressoes.map((p) => {
            return p.curso_rh
              .split(",")[1]
              .replace(/(TÉCNICO EM|TECNÓLOGO EM)/g, "")
              .trim();
          })
        )
      );
      setCursos(cursosUnicos);
    } catch (err) {
      setProgressoes([]);
      setCursos([]);
      console.clear();
    } finally {
      setLoading(false);
    }
  }

  const progressoesFiltradas =
    cursoSelecionado === "todos"
      ? progressoes
      : progressoes.filter((d) => {
          if (typeof d.curso_rh === "string") {
            const curso = d.curso_rh
              .split(",")[1]
              .replace(/(TÉCNICO EM|TECNÓLOGO EM)/g, "")
              .trim();
            return curso === cursoSelecionado;
          }
          return false;
        });

  const Thead = () => (
    <Theader>
      <tr>
        <Th title="Professor">Professor</Th>
        <Th title="Curso">
          {" "}
          <InputSelect
            Style1={{ color: "#f8f8f8" }}
            Style2={{ color: "#f8f8f8", backgroundColor: "#1a2e35" }}
            Style3={{ color: "#f8f8f8", backgroundColor: "#1a2e35" }}
            color="white"
            name="curso"
            placeholder="Selecione o curso"
            value={cursoSelecionado}
            Options={OptionsSelect}
            OnChange={(e) => setCursoSelecionado(e.target.value)}
          />
        </Th>
        <Th title="Turma">Turma</Th>
        <Th title="Disciplina">Disciplina</Th>
        <Th title="Início">Início</Th>
        <Th title="Limite Entrega">Limite Entrega</Th>
        <Th title="Ver Alunos">Ver Alunos</Th>
        {/* <Th title="PDF">PDF</Th>
        <Th title="Informações">Informações</Th> */}
      </tr>
    </Theader>
  );

  return (
    <Page>
      <DivMain>
        <Menus>
          <Title>Turmas Progressão Parcial</Title>
          <Buttons>
            <Button
              event={() => {
                Navigate("/home-progressao");
              }}
              width={pc ? "8rem" : "fit-content"}
              fontsize={!pc && "10px"}
              margintop={pc ? "1%" : "8px"}
              placeholder="Voltar"
              backgroundcolor="#1a2e35"
              borderRadius="30px 30px 0px 0px"
            />
          </Buttons>
          {progressoes.length ? (
            <Description>
              <p>
                <span className="andamento" />
                Em Andamento
              </p>
              <p>
                <span className="emAvaliacao" />
                Em avaliação
              </p>
              <p>
                <span className="terminou" />
                Encerradas
              </p>
            </Description>
          ) : null}
        </Menus>
        {loading ? (
          <ContainerTable $loading={loading}>
            <Loading />
          </ContainerTable>
        ) : (
          <ContainerTable>
            {progressoesFiltradas.length ? (
              <Table>
                {Thead()}
                <Tbody>
                  {progressoesFiltradas.map((d, i) => {
                    const dataAtual = new Date();
                    const dataInicio = new Date(d.data_inicio);
                    const dataFim = new Date(d.data_fim);
                    const andamento = dataAtual >= dataInicio && dataAtual <= dataFim;
                    const terminou = dataAtual > dataFim;
                    const emAvaliacao = terminou && d?.emAvaliacao && !andamento;

                    const turma = d.turma_rh
                      ? d.turma_rh.split(",")[1].split("-").slice(1).join(" - ")
                      : "Turma inválida";

                    const curso = d.curso_rh
                      ? d.curso_rh
                          .split(",")[1]
                          .replace(/(TÉCNICO EM|TECNÓLOGO EM)/g, "")
                          .trim()
                      : "Curso inválido";

                    const professor =
                      typeof d?.professor === "string"
                        ? d?.professor?.split(",")[1]?.trim()?.split(" ").slice(0, 2).join(" ")
                        : "Professor inválido";

                    return (
                      <Trbody key={i}>
                        <Td title={professor}>
                          {emAvaliacao ? (
                            <p>
                              <span className="emAvaliacao" />
                              {professor}
                            </p>
                          ) : terminou ? (
                            <p>
                              <span className="terminou" />
                              {professor}
                            </p>
                          ) : andamento ? (
                            <p>
                              <span className="andamento" />
                              {professor}
                            </p>
                          ) : (
                            <p>{professor}</p>
                          )}
                        </Td>
                        <Td title={curso}>{curso}</Td>
                        <Td title={turma} className="turma">
                          {turma}
                        </Td>
                        <TdDisciplina
                          title={
                            typeof d?.disciplina_rh === "string" ? d.disciplina_rh.split(",")[1] : "Disciplina inválida"
                          }
                        >
                          {typeof d?.disciplina_rh === "string" ? d.disciplina_rh.split(",")[1] : "Disciplina inválida"}
                        </TdDisciplina>
                        <Td title={d?.data_inicio ? format(dataInicio, "dd/MM/yyyy") : "Data inválida"}>
                          {d?.data_inicio ? format(dataInicio, "dd/MM/yyyy") : "Data inválida"}
                        </Td>
                        <Td title={d?.data_fim ? format(dataFim, "dd/MM/yyyy") : "Data inválida"} className="icon">
                          {d?.data_fim ? format(dataFim, "dd/MM/yyyy") : "Data inválida"}
                        </Td>
                        <Td className="icon">
                          <LuEye
                            onClick={() => {
                              setMostrarAlunos(true);
                              setProgressaoEdit(d);
                            }}
                            size={"2rem"}
                            cursor={"pointer"}
                            title="Ver Alunos"
                          />
                        </Td>
                        {/* <Td className="icon">
                          <FaFilePdf
                            onClick={() => {
                              if (!d?.pdf) return Alert({ tipo: "Alert3", mensagem: "Não há pdf disponível!" });
                              else return setPdfProgressao(true), setProgressaoEdit(d);
                            }}
                            size={"1.8rem"}
                            cursor={"pointer"}
                            title="Ver PDF"
                            color={d?.pdf ? "#de000e" : "#535353"}
                          />
                        </Td>
                        <Td className="icon">
                          <MdInfo
                            onClick={() => {
                              setShowForm(true);
                              setProgressaoEdit(d);
                            }}
                            size={"1.8rem"}
                            cursor={"pointer"}
                            title={"informações"}
                            color={"#00a2ff"}
                          />
                        </Td> */}
                      </Trbody>
                    );
                  })}
                </Tbody>
              </Table>
            ) : (
              <>
                <Table>{Thead()}</Table>
                <DivText>Nenhuma Progressão Adicionada</DivText>
              </>
            )}
          </ContainerTable>
        )}
      </DivMain>
      {/* Para ver os alunos da progressão*/}
      <CardListarAlunosPP
        MostrarAlunos={MostrarAlunos}
        setMostrarAlunos={setMostrarAlunos}
        progressaoEdit={progressaoEdit}
      />
      {/* Para ver o PDF da progressão*/}
      {/* <CardVerPdfProgressao Show={pdfProgressao} setShow={setPdfProgressao} progressaoEdit={progressaoEdit} /> */}
      {/* Para ver informações da progressão*/}
      {/* <CardVerInformacoes show={showForm} setShow={setShowForm} progressaoEdit={progressaoEdit} /> */}
    </Page>
  );
};
